/**
 * 检测系统是否处于暗色模式
 * @returns {boolean} true 表示系统处于暗色模式
 */
export const isSystemDarkMode = (): boolean => {
  // 检查浏览器是否支持 matchMedia
  if (window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  return false;
};

/**
 * 监听系统主题变化
 * @param callback - 主题变化时的回调函数，参数为是否暗色模式
 * @returns 返回取消監聽的函數
 */
export const watchSystemTheme = (callback: (isDark: boolean) => void): (() => void) => {
  if (!window.matchMedia) {
    console.warn('当前浏览器不支持 matchMedia API');

    return () => {};
  }

  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  // 定义监听器函数
  const listener = (e: MediaQueryListEvent) => {
    callback(e.matches);
  };

  // 添加监听器（兼容旧版浏览器）
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', listener);
  } else if (mediaQuery.addListener) {
    // Safari < 14 的兼容性處理
    mediaQuery.addListener(listener);
  }

  // 返回取消监听的函数
  return () => {
    if (mediaQuery.removeEventListener) {
      mediaQuery.removeEventListener('change', listener);
    } else if (mediaQuery.removeListener) {
      mediaQuery.removeListener(listener);
    }
  };
};

/**
 * 获取当前系统主题模式
 * @returns {('dark' | 'light')} 系统主题模式
 */
export const getSystemThemeMode = (): 'dark' | 'light' => {
  return isSystemDarkMode() ? 'dark' : 'light';
};
